// Customers List Mutations

export const updateCustomersList = (state, payload) => {
  state.customersList = payload
}

export const fetchCustomerInfo = (state, payload) => {
  state.customerInfo = payload
}

export const setFullCustomersList = (state, payload) => {
  state.fullCustomersList = payload
}

export const setSaleCustomersList = (state, payload) => {
  state.saleCustomersList = payload
}
